import React from 'react';

const Avatar = ({ user, size = 'md' }) => {
  const sizeClasses = {
    xs: 'w-6 h-6 text-xs',
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-16 h-16 text-xl',
    xl: 'w-20 h-20 text-2xl'
  };

  const sizeClass = sizeClasses[size] || sizeClasses.md;
  const proRing = user?.isCoach
    ? 'ring-2 ring-blue-500 ring-offset-1 ring-offset-black'
    : user?.isPremium
    ? 'ring-2 ring-yellow-400 ring-offset-1 ring-offset-black'
    : 'avatar-border';

  if (user?.profilePicture) {
    return (
      <img
        src={user.profilePicture}
        alt={user.name}
        className={`${sizeClass} rounded-full object-cover ${proRing}`}
      />
    );
  }

  return (
    <div className={`${sizeClass} bg-[#16a34a] rounded-full flex items-center justify-center text-pure-white font-medium ${proRing}`}>
      {user?.name?.charAt(0) || '?'}
    </div>
  );
};

export default Avatar;
